module.exports = __webpack_public_path__ + "static/media/launch-24px.76da70d0.svg";